import React from 'react';
const PHASES = [{
  n: '01',
  name: 'Claridad emocional',
  desc: 'Entender por qué quieres lo que quieres antes de firmar nada.'
}, {
  n: '02',
  name: 'Evaluación de clínicas',
  desc: 'Ocho preguntas que separan al especialista serio del oportunista.'
}, {
  n: '03',
  name: 'Planificación financiera',
  desc: 'El costo real: lo que cobra el quirófano y lo que rara vez se conversa.'
}, {
  n: '04',
  name: 'Optimización física',
  desc: 'Las semanas previas que determinan tu recuperación y tu resultado.'
}, {
  n: '05',
  name: 'Gestión de la recuperación',
  desc: 'El valle de los días 8 al 14. Cómo se atraviesa sin arrepentirse.'
}, {
  n: '06',
  name: 'Integración a largo plazo',
  desc: 'Qué cambia en tu cuerpo, finanzas y vida social a los 90 días.'
}];
export function TheMethodSixPhases() {
  return <section className="method-section" data-id="element-160">
      <h2 className="section-h2" data-id="element-161">El método. Seis fases.</h2>
      <p className="section-lead" data-id="element-162">
        Una secuencia, no una colección de consejos. Preparación clínica
        ordenada en seis movimientos — cada uno con su trabajo específico antes
        de tu decisión.
      </p>

      <ol className="method-phases" data-id="element-163">
        {PHASES.map(phase => <li key={phase.n} className="method-phase" data-id="element-164">
            <span className="method-phase__num" aria-hidden="true" data-id="element-165">
              {phase.n}
            </span>
            <div className="method-phase__body" data-id="element-166">
              <h3 className="method-phase__name" data-id="element-167">{phase.name}</h3>
              <p className="method-phase__desc" data-id="element-168">{phase.desc}</p>
            </div>
          </li>)}
      </ol>

      <p className="method-tangibility" data-id="element-169">
        No estás comprando información suelta. Estás entrando a una secuencia
        para pensar mejor antes, elegir mejor durante y recuperarte con más
        claridad después.
      </p>
    </section>;
}